export default __webpack_public_path__ + "static/media/light_bg.c2309e98.jpg";